import { useEffect, useState } from "react";
import { supabase } from "../../supabase/supabase";

// One rpc per session, shared by every caller. Keyed on the user so a sign-in as someone else
// asks again. Not tied to the current organization: access is by the allowed org's members or
// platform admins, whichever org is selected.
let cached: { userId: string; promise: Promise<boolean> } | null = null;

supabase.auth.onAuthStateChange((_event, session) => {
  if (cached && cached.userId !== session?.user?.id) cached = null;
});

function fetchCanDiagnose(userId: string): Promise<boolean> {
  if (cached?.userId === userId) return cached.promise;
  const promise = Promise.resolve(supabase.rpc("can_diagnose_calls"))
    .then(({ data, error }) => !error && data === true)
    .catch(() => false);
  cached = { userId, promise };
  // A failed check is not kept, so the next mount retries.
  promise.then((ok) => {
    if (!ok && cached?.promise === promise) cached = null;
  });
  return promise;
}

export function useCanDiagnose(): { canDiagnose: boolean; loading: boolean } {
  const [state, setState] = useState({ canDiagnose: false, loading: true });

  useEffect(() => {
    let active = true;
    supabase.auth
      .getSession()
      .then(({ data }) => {
        const userId = data.session?.user?.id;
        if (!userId) return false;
        return fetchCanDiagnose(userId);
      })
      .catch(() => false)
      .then((ok) => {
        if (active) setState({ canDiagnose: ok, loading: false });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}
